/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./styles/UploadedFile.scss";
import DeleteIcon from "../VectorIcons/DeleteIcon";
import WrapperInput from "./UploadInputs";

const UploadedFile = (props) => {
  const {
    fileName,
    handleBlur,
    handleRemove,
    file,
    thesaurusFileType,
    index,
    setFileInfo,
    inputName,
    dramaturgyList,
    materialsList,
    isChapter,
    isMaterial,
  } = props;

  const initialDate = new Date();

  const initialState = {
    attachmentTypeId: "",
    version: isMaterial ? 0 : 1,
    numberChaptersBlock: 0,
    numberAttachmentsEpisodes: 0,
    rescheduledDelivery: null,
    rescheduledRelease: null,
    scheduleDelivery: null,
    scheduleRelease: null,
    receiveAt: initialDate,
    blockNumber: 1,
    chapterNumber: 0,
    reason: null,
    structuringReview: null,
    episodeIds: [],
    chapterIds: [],
  };

  const [state, setstate] = useState(initialState);
  const [stateFileType, setStateFileType] = useState("");

  const getType = (ev) => {
    const id = ev.nativeEvent.target.selectedIndex;
    const idText = ev.nativeEvent.target[id].text;
    const newState = {
      id: parseInt(ev.target.value),
      name: idText,
    };

    if (newState.name !== "Capítulo/Episódio" || newState.name !== "Episódio") {
      setstate({
        ...state,
        blockNumber: 1,
        chapterNumber: 0,
        attachmentTypeId: newState.id,
      });
      setStateFileType(newState.name);
    } else {
      setstate({
        ...state,
        attachmentTypeId: newState.id,
      });
      setStateFileType(newState.name);
    }
  };

  const getVersion = (version) => {
    setstate({ ...state, version: version });
  };

  const getDate = (date) => {
    let d = new Date(date);

    setstate({
      ...state,
      receiveAt: d,
    });
  };

  const getBlock = (version) => {
    setstate({
      ...state,
      blockNumber: version,
    });
  };

  const getChapter = (ev) => {
    setstate({
      ...state,
      chapterNumber: ev.target.value,
    });
  };

  const getAttachmentType = (ev) => {
    const materialId = Number(ev.target.value);

    const isEpisode = materialId === 1211;

    const latestItem = isEpisode
      ? null
      : materialsList
          .filter((item) => Number(item.type.id) === materialId)
          .sort((a, b) => b.version - a.version)[0] || null;

    setstate({
      ...state,
      attachmentTypeId: materialId,
      planningId: latestItem?.id || null,
      rescheduledDelivery: null,
      rescheduledRelease: null,
      scheduleDelivery: latestItem?.planning?.delivery || null,
      scheduleRelease: latestItem?.planning?.release || null,
      chapterNumber: latestItem?.episodeNumber || null,
      chapterOrEpisodeNumber: latestItem?.episodeNumber || null,
      version: null,
    });
  };

  const [notDefault, setNotDefault] = useState(false);
  const setStructuringReview = (has) => {
    setNotDefault(true);
    setstate({
      ...state,
      structuringReview: has,
    });
  };

  const getMaterialVersion = (ev) => {
    const selectedVersionNumber = Number(ev?.target?.value);

    const matchedItem =
      materialsList.find(
        (item) =>
          Number(item.type.id) === Number(state.attachmentTypeId) &&
          Number(item.version) === selectedVersionNumber &&
          (Number(state.attachmentTypeId) !== 1211 ||
            Number(item.episodeNumber) === Number(state.chapterOrEpisodeNumber))
      ) || null;

    setstate({
      ...state,
      version: selectedVersionNumber,
      planningId: matchedItem?.id || state.planningId,
    });
  };

  const getReason = (ev) => {
    setstate({ ...state, reason: ev?.target?.value });
  };

  const setEpisodeIds = (ids) => {
    setstate({
      ...state,
      episodeIds: isMaterial ? ids : [],
      chapterIds: isChapter ? ids : [],
    });
  };

  const handleEpisodeChange = (selectedId) => {
    const episodeItems = materialsList
      .filter(
        (item) =>
          Number(item.type.id) === 1211 &&
          Number(item.episodeNumber) === selectedId
      )
      .sort((a, b) => a.version - b.version);

    const firstUnattached = episodeItems.find(
      (item) => !item.attachments?.length
    );
    const selectedItem =
      firstUnattached || episodeItems[episodeItems.length - 1] || null;

    setstate((prev) => ({
      ...prev,
      chapterOrEpisodeNumber: selectedId,
      chapterNumber: selectedId,
      planningId: selectedItem?.id || null,
      version: selectedItem?.version || 1,
      scheduleDelivery: selectedItem?.planning?.delivery || null,
      scheduleRelease: selectedItem?.planning?.release || null,
      rescheduledDelivery: null,
      rescheduledRelease: null,
    }));
  };

  const handleChapterChange = (selectedId) => {
    const chapter = dramaturgyList.find(
      (chapterItem) => Number(chapterItem?.id) === selectedId
    );

    if (!chapter) return;

    setstate((prev) => ({
      ...prev,
      id: chapter.id,
      blockId: chapter.blockId,
      chapterNumber: chapter.chaption,
      blockNumber: chapter.block,
      numberChaptersBlock: chapter.numberChaptersBlock,
      numberAttachmentsEpisodes: chapter.numberAttachmentsEpisodes,
      rescheduledDelivery: chapter.rescheduledDelivery,
      rescheduledRelease: chapter.rescheduledRelease,
      scheduleDelivery: chapter.scheduleDelivery,
      scheduleRelease: chapter.scheduleRelease,
      version: (chapter.version || 0) + 1,
      attachmentTypeId: chapter.attachmentTypeId || 1211,
    }));
  };

  const getChapterAndBlock = (ev) => {
    const selectedId = Number(ev.target.value);

    if (isMaterial) {
      handleEpisodeChange(selectedId);
    } else {
      handleChapterChange(selectedId);
    }
  };

  useEffect(() => {
    setFileInfo(state, index);
    if (notDefault && !state.structuringReview) {
      setstate({ ...state, reason: null });
      setNotDefault(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <div className="uploadedFileContainer">
      <div className="fileHeader">
        <span className="fileName">{fileName}</span>

        <div className="removeButton" onClick={() => handleRemove(file)}>
          <DeleteIcon color="#000" />
        </div>
      </div>

      <WrapperInput
        handleBlur={handleBlur}
        thesaurusFileType={thesaurusFileType}
        state={state}
        getType={getType}
        getVersion={getVersion}
        getDate={getDate}
        stateFileType={stateFileType}
        getBlock={getBlock}
        getChapter={getChapter}
        getAttachmentType={getAttachmentType}
        getChapterAndBlock={getChapterAndBlock}
        getMaterialVersion={getMaterialVersion}
        dramaturgyList={dramaturgyList}
        materialsList={materialsList}
        inputComponent={inputName}
        getReason={getReason}
        setStructuringReview={setStructuringReview}
        setEpisodeIds={setEpisodeIds}
        isChapter={isChapter}
        isMaterial={isMaterial}
      />
    </div>
  );
};

export default UploadedFile;
